import React, { useEffect } from 'react'
import { Button, Form, Input, Radio, Cascader, Select } from 'antd'

// mobx
import { useStore } from '@/store'
import { set, runInAction, toJS } from 'mobx'
import { observer } from 'mobx-react-lite'
// mobx
import cascader from '@/utils/cascader'
import matterTree from '@/utils/cityf'

import { validateNumber, validatePhone, validatLength, validateUser } from '@/utils/check'

const AuthorityInput = ({ title }) => {
  const { AuthorityStore } = useStore()

  useEffect(() => {
    // if (title === '编辑') {
    //   form.setFieldsValue({ password: '' })
    // }
  })

  // 取消按钮
  const [form] = Form.useForm()
  //三级联动
  const cityList = matterTree(cascader)
  //第一个参数value当前显示的数据   第二个参数 selectedOptions 是指当前选择的数据
  let area_code = ''
  // let area_name =''
  const onChange = (value, selectedOptions) => {
    if (selectedOptions) {
      area_code = selectedOptions[2].code
    } else {
      area_code = ""
    }
  }
  {
    console.log(toJS(AuthorityStore.valueData), "hhhhh")
  }
  //三级联动结束
  //表单提交
  const onFinish = async (values) => {
    values.username = values.username.trim()
    if (title === '添加') {
      if (values.area_name instanceof Array) {
        values.area_name = values.area_name.join("-")
      }
      delete values.quepassword
      // console.log(values.password.length, "password")
      await AuthorityStore.getAddButtom(values)
    } else if (title === '编辑') {
      if (values.area_name instanceof Array) {
        values.area_name = values.area_name.join("-")
      }
      delete values.quepassword
      await AuthorityStore.getPutInformation(values)
    }

  };

  return (
    <>
      {
        title === '添加' && <Form
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 14,
          }}
          form={form}
          onFinish={onFinish}
          initialValues={{
            status: 'normal'
          }}
        >
          <Form.Item label="用户名" name="username"
            rules={[
              {
                required: true,
                message: '请输入用户名',
              },
              {
                validator: validateUser
              }
            ]}
          >
            <Input placeholder="请输入" />
          </Form.Item>
          <Form.Item
            label='输入密码'
            name="password"
            rules={[
              {
                required: true,
                message: '请输入密码',
              },
              {
                validator: validateNumber
              },
            ]}
            autoComplete="off"
          >
            <Input.Password placeholder="输入密码(至少输入6位)" />
          </Form.Item>
          <Form.Item
            label='确认密码'
            name="quepassword"
            rules={[
              {
                required: true,
                message: '请输确认密码',
              },
              ({ getFieldValue }) => ({
                validator(rule, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve()
                  }
                  return Promise.reject('您输入的两次密码不一致')
                },
              })
            ]}
            autoComplete="off"
          >
            <Input.Password placeholder="请确认密码(至少输入6位)" />
          </Form.Item>
          <Form.Item label="昵称" name="nickname"
            rules={[
              {
                required: true,
                message: '请输入昵称',
              },
              {
                validator: validatLength
              }
            ]}>
            <Input placeholder="请输入" />
          </Form.Item>
          <Form.Item label="手机号" name="mobile"
            rules={[
              { required: true, message: '请输入手机号' },
              {
                validator: validatePhone
              }
            ]}
          >
            <Input placeholder="请输入" />
          </Form.Item>
          <Form.Item label="地区" name="area_name"
            rules={[
              {
                required: true,
                message: '请选择地区',
              },
            ]}
          >
            <Cascader options={cityList} onChange={onChange} placeholder="请选择" />
          </Form.Item>
          <Form.Item label="角色名称" name='group_id'
            rules={[
              {
                required: true,
                message: '角色名称',
              }
            ]}>
            <Select placeholder="请选择" options={toJS(AuthorityStore.selectList)}>
            </Select>
          </Form.Item>
          <Form.Item label="所属系统" name='jrxtid'
            rules={[
              {
                required: true,
                message: '所属系统',
              }
            ]}>
            <Select placeholder="请选择" options={toJS(AuthorityStore.selectList2)}>
            </Select>
          </Form.Item>
          <Form.Item label="角色状态" name="status" rules={[
            {
              required: true,
              message: '请选择角色状态',
            }
          ]}>
            <Radio.Group>
              <Radio value={'normal'}>启用</Radio>
              <Radio value={'hidden'}>禁用</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 6 }}>
            <Button type="primary" htmlType="submit">
              立即添加
            </Button>
          </Form.Item>
        </Form>
      }
      {
        title === '编辑' && <Form
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 14,
          }}
          form={form}
          onFinish={onFinish}
          initialValues={{ ...AuthorityStore.valueData, group_id: parseInt(AuthorityStore.valueData.groups) }}
        >
          <Form.Item label="用户名" name="username"
            rules={[
              {
                required: true,
                message: '请输入用户名',
              },
              {
                validator: validateUser
              }
            ]}
          >
            <Input placeholder="请输入" />
          </Form.Item>
          <Form.Item
            label='输入密码'
            name="password"
            rules={[
              {
                required: true,
                message: '请输入密码',
              },
              {
                validator: validateNumber
              },
            ]}
          // autoComplete="off"
          >
            <Input.Password placeholder="输入密码(至少输入6位)" />
          </Form.Item>
          <Form.Item
            label='确认密码'
            name="quepassword"
            rules={[
              {
                required: true,
                message: '请输确认密码',
              },
              ({ getFieldValue }) => ({
                validator(rule, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve()
                  }
                  return Promise.reject('您输入的两次密码不一致')
                },
              })
            ]}
            autoComplete="off"
          >
            <Input.Password placeholder="请确认密码(至少输入6位)" />
          </Form.Item>
          <Form.Item label="昵称" name="nickname"
            rules={[
              {
                required: true,
                message: '请输入昵称',
              },
              {
                validator: validatLength
              }
            ]}>
            <Input placeholder="请输入" />
          </Form.Item>
          <Form.Item label="手机号" name="mobile"
            rules={[
              {
                required: true,
                message: '请输入手机号'
              },
              {
                validator: validatePhone
              }
            ]}
          >
            <Input placeholder="请输入" />
          </Form.Item>
          <Form.Item label="地区" name="area_name"
            rules={[
              {
                required: true,
                message: '请选择地区',
              },
            ]}
          >
            <Cascader options={cityList} onChange={onChange} placeholder="请选择" />
          </Form.Item>
          <Form.Item label="角色名称" name='group_id'
            rules={[
              {
                required: true,
                message: '角色名称',
              }
            ]}>
            <Select placeholder="请选择" options={toJS(AuthorityStore.selectList)}>
            </Select>
          </Form.Item>
          <Form.Item label="所属系统" name='jrxtid'
            rules={[
              {
                required: true,
                message: '所属系统',
              }
            ]}>
            <Select placeholder="请选择" options={toJS(AuthorityStore.selectList2)}>
            </Select>
          </Form.Item>
          <Form.Item label="角色状态" name="status" rules={[
            {
              required: true,
              message: '请选择角色状态',
            }
          ]}>
            <Radio.Group>
              <Radio value={'normal'}>启用</Radio>
              <Radio value={'hidden'}>禁用</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 6 }}>
            <Button type="primary" htmlType="submit">
              修改内容
            </Button>
          </Form.Item>
        </Form>
      }
    </>
  )
}

export default observer(AuthorityInput)